import $ from 'jquery'

var lastActiveElement = $('.js-ride.is-active');

$('.js-ride').hover(
    function() {
        var mediaQuery = window.matchMedia('(min-width: 991px)');
        if ( mediaQuery.matches ) {
            $('.js-ride').removeClass('is-active');
            $('.js-route-img').removeClass('is-active');

            $(this).addClass('is-active');
            var dataId = $(this).data('id');
            $('.js-route-img[data-id="' + dataId + '"]').addClass('is-active');
        }
    },
    function() {
        var mediaQuery = window.matchMedia('(min-width: 991px)');
        if ( mediaQuery.matches ) {
            if (!$(this).hasClass('clicked')) {
                $(this).removeClass('is-active');
                var hoverDataId = $(this).data('id');
                $('.js-route-img[data-id="' + hoverDataId + '"]').removeClass('is-active');

                lastActiveElement.addClass('is-active');
                var dataId = lastActiveElement.data('id');
                $('.js-route-img[data-id="' + dataId + '"]').addClass('is-active');
            }
        }
    }
);

$('.js-ride').click(function() {
    var mediaQuery = window.matchMedia('(min-width: 991px)');
    if ( mediaQuery.matches ) {
          $('.js-ride').removeClass('clicked');
          $(this).addClass('clicked');

          lastActiveElement = $(this);
    }
    else {
        var modalId = $(this).data('id');
        var modalSelector = '#rideModal' + modalId;
        $(modalSelector).modal('show');
    }
});
